import { STEPS } from '@/shared/constants';
import { ICourse } from '@/shared/ICourse';
import { Text, Button, Modal, ModalOverlay, ModalContent, ModalHeader, ModalCloseButton, ModalBody, ModalFooter, Checkbox, FormControl } from '@chakra-ui/react'
import React from 'react'
import { useNavigate } from 'react-router-dom';

export const SubmitSmallChangesDialog = (props: {
  course: ICourse;
  onClose: () => void;
}) => {

  const initialRef = React.useRef(null)

  const [isConfirmed, setIsConfirmed] = React.useState(false);

  const navigate = useNavigate();

  const onSubmit = () => {
    navigate(`/course/${props.course.id}/${STEPS.COMPLETED}/new`);
  }

  return (
    <Modal
      initialFocusRef={initialRef}
      finalFocusRef={initialRef}
      size='xl'
      isOpen
      onClose={props.onClose}
      preserveScrollBarGap
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Submit Small Changes</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          <Text mb={4}>
            This form is only intended for submitting <strong>small changes</strong> for a new run of the course.
            Please note that the following changes are considered <strong>major changes</strong> and require a new EIT Label application:
          </Text>
          <ul style={{ marginLeft: 24, marginTop: 8, marginBottom: 16 }}>
            <li>Changes to the target audience</li>
            <li>Changes to the level</li>
            <li>Changes to the OLOs</li>
            <li>Changes to over one third of the ILOs</li>
            <li>Changes to the assessment method, format, or timing</li>
            <li>Changes to delivery method (synchronous, asynchronous, mixed)</li>
          </ul>
          <Text mb={4}>
            In case you have them, you must re-apply for the EIT Label and cannot use this form.
            In this case, please contact your EIT UM SPOC person for further guidance.
          </Text>

          <FormControl>
            <Checkbox size='lg'
              ref={initialRef}
              isChecked={isConfirmed}
              onChange={(e) => setIsConfirmed(e.target.checked)}
            >
              <Text ml={2} fontWeight={600}>I confirm that only small changes are being submitted.</Text>
              <Text ml={2} fontSize='sm' color='fg.subtle'>Please kindly confirm that none of the above major changes apply</Text>
            </Checkbox>
            

          </FormControl>


        </ModalBody>

        <ModalFooter>
          <Button variant='solid' isDisabled={!isConfirmed} mr={4} onClick={onSubmit}>
            {'Continue'}
          </Button>
          <Button variant='outline' onClick={props.onClose}>Cancel</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  )
}